<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="col-sm-12">
      <div class="card card-body">
        <div class="overflow-auto">
          <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
            <thead>
            <tr>
              <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.currency') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
              <th class="text-capitalize-first">{{ helper.trans('dashboard.on_hold') }}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="account in accountItems" :key="account.id" class="">
              <td>
                <span v-b-tooltip.hover :title="account.id">{{ account.id.substring(0, 8) }}...</span> <copy-button :value="account.id"></copy-button>
              </td>
              <td>
                {{ account.currency }}
              </td>
              <td>
                {{ numberFormatter.formatNumber(account.sum) }}
              </td>
              <td>
                {{ numberFormatter.formatNumber(account.frozenSum) }}
              </td>
              <td class="text-end">
                <button v-if="store.getters.hasPermission(UserPermission.WITHDRAW_FROM_SYSTEM_ACCOUNT)" @click.prevent="withdrawAccount = account" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first me-2">
                  <i class="fa-solid fa-upload"></i> {{ helper.trans("button.withdraw") }}
                </button>

                <button v-if="accountForDetails !== null" type="button" @click.prevent="accountForDetails = null" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize">
                  <i class="fa fa-arrow-left"></i> {{ helper.trans('button.back')}}
                </button>
                <button v-else @click.prevent="accountForDetails = account" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first">
                  {{ helper.trans("menu.items.accountOperations") }}
                </button>

              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
    <AccountOperations v-if="accountForDetails" :account="accountForDetails" :class="'m-0'"></AccountOperations>
    <b-modal :title="helper.trans('labels.withdrawal')" :modelValue="withdrawAccount !== null" header-class="text-capitalize" body-class="pt-0" footer-class="d-flex justify-content-between" @update:modelValue="$event === false && (withdrawAccount = null)">
      <template #default>
        <WithdrawalForm ref="withdrawalForm" :account="withdrawAccount"></WithdrawalForm>
      </template>
      <template #footer>
        <button type="button" v-on:click="withdrawAccount = null" class="btn btn-outline-dark btn-sm text-capitalize-first">{{ helper.trans("button.cancel") }}</button>
        <LoaderWrapper ref="loaderWithdrawalForm" :zoom="0.5">
          <button type="button" v-on:click="createWithdraw()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans("button.withdraw") }}</button>
        </LoaderWrapper>
      </template>
    </b-modal>
  </LoaderWrapper>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import APIClient from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import AccountDTO from "@/models/AccountDTO";
import AccountOperations from "@/views/AccountOperations.vue";
import WithdrawalForm from "@/components/Form/WithdrawalForm.vue";
import {useStore} from "vuex";
import {UserPermission} from "@/models/enum/UserPermission";

const api = new APIClient();

export default defineComponent({
  components: {
    WithdrawalForm,
    LoaderWrapper,
    CopyButton,
    AccountOperations
  },
  props: {},
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderWithdrawalForm = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const withdrawalForm = ref<InstanceType<typeof WithdrawalForm> | null>(null)

    const state = reactive({
      withdrawAccount: null as AccountDTO|null,
      accounts: [] as AccountDTO[],
      accountForDetails: null as AccountDTO|null
    });

    const loadAccounts = async () => {
      loader.value?.show()
      state.accounts = await api.accountsAll()
      loader.value?.hide()
    }

    const accountItems = computed<AccountDTO[]>(() => {
      if (state.accountForDetails === null) {
        return state.accounts
      }

      return [state.accountForDetails]
    })

    const createWithdraw = async () => {
      loaderWithdrawalForm.value?.show()
      withdrawalForm.value?.save().then(() => {
        state.withdrawAccount = null;
        loaderWithdrawalForm.value?.hide()
        loadAccounts()
      }).catch(() => {
        loaderWithdrawalForm.value?.hide()
      })
    }

    onMounted(() => {
      loadAccounts()
    });

    return {
      ...toRefs(state),
      store,
      createWithdraw,
      loader,
      withdrawalForm,
      loaderWithdrawalForm,
      dateHelper,
      numberFormatter,
      helper,
      accountItems,
      UserPermission
    }
  }
})
</script>
